import { render, staticRenderFns } from "./plan-tooltip.vue?vue&type=template&id=ddb44936"
import script from "./plan-tooltip.vue?vue&type=script&lang=js"
export * from "./plan-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports